import fetch from '../fetch'
import { CaseReportGetParams } from './load'

export default ({ id }: CaseReportGetParams) => {
  const token = localStorage.getItem('token')
  return fetch({
    method: 'POST',
    path: `api/v1/case-report/${id}/submit`,
    headers: {
      Authorization: token && `Bearer ${token}`,
    },
  })
}
